var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStroke = function SvgStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 1.5,
    x: 5.5,
    y: 8.25,
    fill: "currentColor",
    rx: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 2.5,
    x: 5.5,
    y: 13.75,
    fill: "currentColor",
    rx: 1.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 3.5,
    x: 5.5,
    y: 20.25,
    fill: "currentColor",
    rx: 1.75
  })));
};
export default SvgStroke;